import { render, staticRenderFns } from "./enterstd_rec.vue?vue&type=template&id=6521f0f4&scoped=true"
import script from "./enterstd_rec.vue?vue&type=script&lang=js"
export * from "./enterstd_rec.vue?vue&type=script&lang=js"
import style0 from "./enterstd_rec.vue?vue&type=style&index=0&id=6521f0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521f0f4",
  null
  
)

export default component.exports